var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBottle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00A5FF"
    },
    d: "M307.2,136.79v-9.474c15.078-14.485,23.451-34.833,22.71-56.001 c-1.349-38.468-32.531-69.768-70.99-71.258c-20.294-0.783-39.563,6.527-54.188,20.597c-14.63,14.075-22.687,33.005-22.687,53.301 c0,20.473,8.197,39.49,22.755,53.382v9.453c-31.851,2.882-56.889,29.732-56.889,62.322v39.822h216.177v-39.822 C364.089,166.523,339.052,139.672,307.2,136.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0088FF"
    },
    d: "M307.2,136.79v-9.474c15.078-14.485,23.451-34.833,22.71-56.001 c-1.349-38.468-32.531-69.768-70.99-71.258c-0.976-0.038-1.949-0.04-2.92-0.04v238.917h108.089v-39.822 C364.089,166.523,339.052,139.672,307.2,136.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB64C"
    },
    d: "M147.911,204.801v267.377c0,21.958,17.864,39.822,39.822,39.822h136.533 c21.958,0,39.822-17.864,39.822-39.822V204.801H147.911z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9800"
    },
    d: "M256,204.801V512h68.267c21.958,0,39.822-17.864,39.822-39.822V204.801H256z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 273.066,
    style: {
      fill: "#FF4F19"
    },
    width: 108.089,
    height: 34.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 341.333,
    style: {
      fill: "#FF4F19"
    },
    width: 108.089,
    height: 34.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 409.599,
    style: {
      fill: "#FF4F19"
    },
    width: 108.089,
    height: 34.133
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottle);
export default __webpack_public_path__ + "static/media/bottle.2dcfb7bea8c11cf3a53c70282c6702d7.svg";
export { ForwardRef as ReactComponent };